import { TypographySettings } from '@theme/globals/typography';

const heading = {
  level: {
    '1': {
      font: TypographySettings.h1,
      small: { maxWidth: 'none' },
      medium: { maxWidth: 'none' },
      large: { maxWidth: 'none' },
      xlarge: { maxWidth: 'none' },
    },
    '2': {
      font: TypographySettings.h2,
      small: { maxWidth: 'none' },
      medium: { maxWidth: 'none' },
      large: { maxWidth: 'none' },
      xlarge: { maxWidth: 'none' },
    },
    '3': {
      font: TypographySettings.h3,
      small: { maxWidth: 'none' },
      medium: { maxWidth: 'none' },
      large: { maxWidth: 'none' },
      xlarge: { maxWidth: 'none' },
    },
    '4': {
      font: TypographySettings.h4,
      small: { maxWidth: 'none' },
      medium: { maxWidth: 'none' },
      large: { maxWidth: 'none' },
      xlarge: { maxWidth: 'none' },
    },
    '5': {
      font: TypographySettings.h5,
      small: { maxWidth: 'none' },
      medium: { maxWidth: 'none' },
      large: { maxWidth: 'none' },
      xlarge: { maxWidth: 'none' },
    },
  },
  responsiveBreakpoint: undefined,
  weight: 600,
  skeleton: {
    width: {
      min: '150px',
      max: '200px',
    },
  },
};
export default heading;
